import exitIntentPopup from "../exitIntentPopup"
import primer from "../primer"

export default (getView) => (nextStepPath, popupStepPath, externalCheckoutPath) => ({
  ...getView(nextStepPath),
  ...primer(),
  ...exitIntentPopup(popupStepPath),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    const externalCheckout = pipelineConfig.variant.includes("External-Checkout")

    if (!externalCheckout) {
      this.addConfirmationEventListener()
      this.initPrimer({
        checkoutCompletePath: nextStepPath,
      })
    }
    this.initExitIntentPopup()
    this.store.restorePurchasedBasicOffer()
  },

  goToExternalPaymode(hideApm = false) {
    this.store.values.hideApm = hideApm
    window.location = this.store.addTokenHashParam(externalCheckoutPath)
  },
})
